import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, store } from "../../lib/api";

export default function ReferralEntry() {
  const { code: pathCode } = useParams();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const code = pathCode || sp.get("ref");

  useEffect(() => {
    if (!code) {
      nav("/start", { replace: true });
      return;
    }
    const utm = {};
    for (const [k, v] of sp.entries()) if (k.startsWith("utm_")) utm[k] = v;
    api.post("/track/visit", { code, src: sp.get("src"), visitor_id: store.visitor, landing: window.location.pathname, utm })
      .then(({ data }) => {
        store.visit = data.visit_id;
        store.visitor = data.visitor_id;
        sessionStorage.setItem("aj_ref", data.code);
        nav("/start", { replace: true });
      })
      .catch(() => nav("/start?invalid=1", { replace: true }));
  }, [code]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="grid min-h-screen place-items-center" data-testid="referral-entry-loading">
      <Loader2 className="h-8 w-8 animate-spin text-slate-500" />
    </div>
  );
}
